import React from 'react';

import plusIcon from './util/images/plus.svg';

export type AddAppButtonProps = {
  onClick: () => void;
};

export const AddAppButton: React.FC<AddAppButtonProps> = React.memo((props) => {
  const { onClick } = props;

  return (
    <button
      onClick={onClick}
      className="flex flex-col justify-center items-center gap-8 p-16 sm:p-24 rounded-[12px] border-primary border-[1px] border-dashed bg-primary-5 min-h-[144px] w-full"
    >
      <div className="flex items-center justify-center rounded-[50%] w-32 h-32 bg-[linear-gradient(90deg,_#584BEA_0%,_#905CFF_100%)]">
        <img src={plusIcon} width={14} height={24} alt="add" />
      </div>
      <p className="text-m15">Add custom app</p>
    </button>
  );
});
